module.exports = __webpack_public_path__ + "static/media/Avfall.96297ef7.m4a";